import { lazy } from 'react';
import type { ModuleRoute } from '@/modules/crm/routes';

const Highlights = lazy(() => import('@/modules/shared/pages/Highlights'));
const ActivityFeed = lazy(() => import('@/modules/shared/pages/ActivityFeed'));
const Automacoes = lazy(() => import('@/modules/shared/pages/Automacoes'));
const Configuracoes = lazy(() => import('@/modules/shared/pages/Configuracoes'));
const AIKnowledgeDashboard = lazy(() => import('@/modules/shared/pages/AIKnowledgeDashboard'));

// Build CRM (crm.blacklegacy.com.br): todas as rotas compartilhadas só
// aceitam projetos CRM nesta build.
export const sharedRoutes: ModuleRoute[] = [
  { path: '/highlights', component: Highlights, allowedTypes: ['crm'] },
  { path: '/atividades', component: ActivityFeed, allowedTypes: ['crm'] },
  { path: '/automacoes', component: Automacoes, allowedTypes: ['crm'] },
  { path: '/configuracoes', component: Configuracoes, allowedTypes: ['crm'] },
  { path: '/integracoes', component: Configuracoes, allowedTypes: ['crm'] },
  { path: '/ai-knowledge', component: AIKnowledgeDashboard, allowedTypes: ['crm'] },
];
